// @flow
import { connect } from 'react-redux';
import { get } from 'lodash';

import { getResortInitialKids } from 'Utils/trip-information/tripInformationUtils';
import { DEFAULT_ADULTS_NB } from 'Store/trip-information/adults/constants';
import { setKids } from 'Store/trip-information/kids/kids.action';
import { setAdultsNumber } from 'Store/trip-information/adults/adults.action';
import { CruiseBooking } from 'Components/widgets/cruise-booking/CruiseBooking.jsx';
import { getBookingEngineI18n } from 'Store/cms/cms.actions';
import { simpleFetchProposals } from 'Store/booking/proposals/proposals.action';
import { getKids, getAdults } from 'Store/trip-information/storeHelper';

type ComponentProps = {
  bookingCriteria?: {
    initialNumberOfChildren?: number,
    initialNumberOfAdults?: number,
  },
  resort?: {
    adultOnly?: boolean,
  },
};

export type ContainerProps = {
  adultsNumber: number,
  kids: Array<*>,
  setKids: typeof setKids,
  setAdultsNumber: typeof setAdultsNumber,
  simpleFetchProposals: typeof simpleFetchProposals,
};

function getValue<T>(value: ?T, cmsDefaultValue: T): ?T {
  return !value && cmsDefaultValue ? cmsDefaultValue : value;
}

export function mapStateToProps(state: ReduxState, props: ComponentProps) {
  const { bookingCriteria, resort } = props;
  const kids = getKids(state);
  const adultsNumber = (getAdults(state) || []).length;
  return {
    adultsNumber:
      getValue(adultsNumber, get(bookingCriteria, 'initialNumberOfAdults')) || DEFAULT_ADULTS_NB,
    kids: getResortInitialKids(
      kids,
      get(bookingCriteria, 'initialNumberOfChildren'),
      get(resort, 'adultOnly'),
    ),
    i18n: state.cms,
  };
}

export const mapDispatchToProps = {
  setKids,
  setAdultsNumber,
  simpleFetchProposals,
  getBookingEngineI18n,
};

export const CruiseBookingContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CruiseBooking);
